var React = require('react');

function WebIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M38.95 7.227V2.065H6.15v5.162h32.8zm0 2.064H6.15v17.55h32.8V9.291zm-1.025 19.615v2.03c0 1.14-.918 2.064-2.05 2.064H2.05C.918 33 0 32.076 0 30.935V6.16c0-1.14.918-2.065 2.05-2.065H4.1v-2.03C4.1.925 5.018 0 6.15 0h32.8C40.082 0 41 .924 41 2.065V26.84c0 1.14-.918 2.065-2.05 2.065h-1.025zM4.1 6.159H2.05v24.776h33.825v-2.029H6.15c-1.132 0-2.05-.924-2.05-2.065V6.16zm5.638.035c-.85 0-1.538-.692-1.538-1.548 0-.855.689-1.549 1.538-1.549.848 0 1.537.694 1.537 1.549 0 .856-.689 1.548-1.537 1.548zm5.125 0c-.85 0-1.538-.692-1.538-1.548 0-.855.689-1.549 1.538-1.549.848 0 1.537.694 1.537 1.549 0 .856-.689 1.548-1.537 1.548zm5.125 0c-.85 0-1.538-.692-1.538-1.548 0-.855.689-1.549 1.538-1.549.848 0 1.537.694 1.537 1.549 0 .856-.689 1.548-1.537 1.548z"}));
}

WebIcon.defaultProps = {"viewBox":"0 0 41 33"};

module.exports = WebIcon;

WebIcon.default = WebIcon;
